/**
 * C&H Signs — pricing page category navigation
 * Active section highlighting and smooth scroll (nav lives inside sticky site header).
 */
(function () {
  'use strict';

  var nav = document.querySelector('[data-ch-pricing-nav]');
  if (!nav) return;

  var scrollEl = nav.querySelector('[data-ch-pricing-nav-scroll]');
  var links = nav.querySelectorAll('[data-ch-pricing-nav-link]');
  var header = document.querySelector('[data-ch-header]');
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var sectionIds = [
    'banners',
    'retractable-banners',
    'shirts',
    'dtf-transfers',
    'sublimation',
    'custom-signs',
    'car-decals',
    'vehicle-magnets',
    'business-cards',
    'keychains',
    'custom-cutouts'
  ];
  var legacySectionMap = {
    standees: 'custom-cutouts',
    'car-decals-magnets': 'car-decals'
  };
  var sections = [];
  var sectionObserver = null;
  var activeId = '';

  function resolveSectionId(id) {
    if (!id) return id;
    return legacySectionMap[id] || id;
  }

  function headerHeight() {
    return header ? Math.ceil(header.getBoundingClientRect().height) : 68;
  }

  function readScrollOffset() {
    var raw = getComputedStyle(document.documentElement).getPropertyValue('--ch-pricing-scroll-offset');
    var parsed = parseFloat(raw);
    return Number.isFinite(parsed) ? parsed : 120;
  }

  function setHeaderVars() {
    var navHeight = nav.offsetHeight;
    var headerBar = header ? header.querySelector('.chc-header__bar') : null;
    var headerBarHeight = headerBar ? Math.ceil(headerBar.getBoundingClientRect().height) : headerHeight();

    document.documentElement.style.setProperty('--ch-site-header-height', headerBarHeight + 'px');
    document.documentElement.style.setProperty('--ch-pricing-nav-height', navHeight + 'px');
    document.documentElement.style.setProperty('--ch-pricing-scroll-offset', headerHeight() + 16 + 'px');
  }

  function scrollActiveLinkIntoView(link) {
    if (!scrollEl || !link) return;

    var targetLeft = link.offsetLeft - scrollEl.clientWidth / 2 + link.offsetWidth / 2;
    scrollEl.scrollTo({
      left: Math.max(0, targetLeft),
      behavior: reduceMotion ? 'auto' : 'smooth'
    });
  }

  function setActive(id, scrollLink) {
    var resolvedId = resolveSectionId(id);
    if (!resolvedId || activeId === resolvedId) return;
    activeId = resolvedId;

    links.forEach(function (link) {
      var isActive = link.getAttribute('data-section') === resolvedId;
      link.classList.toggle('is-active', isActive);

      if (isActive) {
        link.setAttribute('aria-current', 'location');
        if (scrollLink !== false) scrollActiveLinkIntoView(link);
      } else {
        link.removeAttribute('aria-current');
      }
    });
  }

  function bindSectionObserver() {
    if (sectionObserver) {
      sectionObserver.disconnect();
      sectionObserver = null;
    }

    if (!('IntersectionObserver' in window) || !sections.length) return;

    var topInset = Math.round(headerHeight() + 8);

    sectionObserver = new IntersectionObserver(
      function (entries) {
        var visible = entries
          .filter(function (entry) {
            return entry.isIntersecting;
          })
          .sort(function (a, b) {
            return b.intersectionRatio - a.intersectionRatio;
          });

        if (visible.length) {
          setActive(visible[0].target.id);
        }
      },
      {
        root: null,
        rootMargin: '-' + topInset + 'px 0px -50% 0px',
        threshold: [0, 0.12, 0.3, 0.5, 0.75]
      }
    );

    sections.forEach(function (section) {
      sectionObserver.observe(section);
    });
  }

  links.forEach(function (link) {
    link.addEventListener('click', function (event) {
      var href = link.getAttribute('href');
      if (!href || href.charAt(0) !== '#') return;

      var targetId = resolveSectionId(href.slice(1));
      var target = document.getElementById(targetId);
      if (!target) return;

      event.preventDefault();
      var top = target.getBoundingClientRect().top + window.pageYOffset - readScrollOffset();

      window.scrollTo({
        top: Math.max(0, top),
        behavior: reduceMotion ? 'auto' : 'smooth'
      });

      setActive(targetId, false);
      history.replaceState(null, '', '#' + targetId);
    });
  });

  sectionIds.forEach(function (id) {
    var section = document.getElementById(id);
    if (section) sections.push(section);
  });

  if (window.location.hash) {
    var hashId = resolveSectionId(window.location.hash.replace('#', ''));
    if (sectionIds.indexOf(hashId) !== -1) {
      setActive(hashId, true);
    }
  }

  function init() {
    setHeaderVars();
    bindSectionObserver();
  }

  init();
  window.addEventListener('resize', init, { passive: true });
  window.addEventListener('load', init, { passive: true });
})();
